<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box-name">
      <div class="select-label">{{appName}}</div>
      <img class="select_icon_url" :src="appIcon" />
    </div>
    <div class="option-wrap">
      <Row>
        <Col  style="margin-bottom:20px;">
          <RadioGroup v-model="defaultType" type="button" @on-change="loadData">
            <Radio label="安卓"></Radio>
            <Radio label="鸿蒙"></Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row>
        <Col >
          <Button :disabled="this.uid !== this.userId" type="primary" @click="newAlert"><Icon type="md-add" size="15" /> 上传小程序新版本</Button>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col :span="4" class="version-col">
          <Input placeholder="请输入版本号"
                 v-model="searchParams.package_ver"
                 />
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="审核状态" v-model="searchParams.aduit_stats" clearable >
            <Option value="0">未提审</Option>
            <Option value="1">待审核</Option>
            <Option value="2">审核通过</Option>
            <Option value="3">审核驳回</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="版本状态" v-model="searchParams.package_stats" clearable >
            <Option value="0">预览版本</Option>
            <Option value="2">线上版本</Option>
            <Option value="3">历史版本</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="SDK最小版本" v-model="searchParams.sdk_ver_s" clearable >
            <Option v-for="(option, index) in sdkVerList" :value="option.value" :key="index">{{option.text}}</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="主插件版本" v-model="searchParams.min_plugin_ver_code" clearable >
            <Option v-for="(option, index) in minPluginVerList" :value="option.value" :key="index">{{option.text}}</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="请输入宿主名称" v-model="searchParams.runtime" clearable >
            <Option v-for="(option, index) in runtimeList" :value="option.value" :key="index">{{option.label}}</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Input placeholder="请输入宿主版本"
                 v-model="searchParams.runtimeVersion"
                 />
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="渠道" v-model="searchParams.channel" clearable >
            <Option :value="item.value" v-for="(item, index) in channelList" :key="index">{{item.label}}</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="安卓版本" v-model="searchParams.android" clearable >
            <Option :value="item.value" v-for="(item, index) in androidVerList" :key="index">{{item.label}}</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="强制升级状态" v-model="searchParams.refresh" clearable >
            <Option value="1">开启</Option>
            <Option value="0">关闭</Option>
          </Select>
        </Col>
        <Col :span="4" class="version-col">
          <Select placeholder="更新弹窗状态" v-model="searchParams.updatePopupSwitch" clearable >
            <Option value="1">开启</Option>
            <Option value="0">关闭</Option>
          </Select>
        </Col>
        <Col :span="6" class="version-col">
          <Button type="primary" @click="handleSearch">查询客户端命中版本</Button>
          <Button @click="handleClear">重置</Button>
        </Col>
      </Row>
    </div>
    <!-- 指定版本灰度 暂时不展示 -->
    <!-- <div v-show="multiOnlineList.length > 0">
      <h3>指定版本灰度：</h3>
      <br/>
      <Table  class="spacingTwice" border :columns="columnsGray" :data="multiOnlineList"></Table>
    </div> -->
    <!-- 指定版本线上 -->
    <div v-show="multiOnline.length > 0 && defaultType == '安卓'">
      <h3>指定版本线上：</h3>
      <br/>
      <Table  class="spacingTwice" border :columns="columnsGray" :data="multiOnline"></Table>
    </div>
    <!-- 通用灰度版本 -->
    <div v-show="grayList.length > 0 && defaultType == '安卓'">
      <h3>通用灰度版本：</h3>
      <br/>
      <Table class="spacingTwice" border :columns="columnsGray" :data="grayList"></Table>
    </div>
    <!-- 通用版本 -->
    <div v-show="onlineList.length > 0">
      <h3>通用线上版本：</h3>
      <br/>
      <Table class="spacingTwice" border :columns="columnsOnline" :data="onlineList"></Table>
    </div>
    <!-- 版本列表 -->
    <h3>版本列表：</h3>
    <br/>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <!-- 新增/编辑弹窗 -->
    <Modal
      width="600"
      :mask-closable="false"
      v-model="showModal"
      :title="modalType == 'edit' ? '编辑版本' : '上传版本'"
      :loading="loading"
      @on-cancel="cancelModal"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="应用运行平台" prop="os">
          <RadioGroup v-model="defaultType">
            <Radio label="安卓" :disabled="true"></Radio>
            <Radio label="鸿蒙" :disabled="true"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="版本号" prop="package_ver">
          <Input v-model="formValidate.package_ver" :disabled="shouldDisableField" placeholder="请输入版本号，需三段，以小数点分隔。例如1.0.0" />
        </FormItem>
        <FormItem label="上传代码包" prop="fileName" v-if="modalType == 'add' || currentAduit != -1">
          <img class="file_must_ic" src="../../assets/must_ic.jpg" />
          <label class="file-wrap">
            <input class="file-input" type="file" ref="file" accept=".zip,.rpk,.tpk" @change="uploadFile('file')" />
            <Button icon="ios-cloud-upload-outline">{{formValidate.fileName || '上传'}}</Button>
          </label>
          <div class="tips">文件格式为zip,rpk,tpk,将项目编译后dist文件夹中的android文件夹进行压缩上传到此处。</div>
        </FormItem>
        <FormItem label="SDK最小版本" v-show="defaultType === '安卓'" prop="sdk_ver_s">
          <Select
                :disabled="shouldDisableField"
                v-model="formValidate.sdk_ver_s"
                placeholder="请选择版本"
                filterable
                >
                <Option v-for="(option, index) in sdkVerList" :value="option.value" :key="index">{{option.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="指定主插件版本" v-show="defaultType == '安卓'">
          <Select
                :disabled="shouldDisableField"
                v-model="formValidate.min_plugin_ver_code"
                placeholder="请选择版本"
                filterable
                >
                <Option v-for="(option, index) in minPluginVerList" :value="option.value" :key="index">{{option.text}}</Option>
            </Select>
            <p>仅限runtime2.9(含)以上使用</p>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :specifyRuntimeList="2" />
        </FormItem>
        <FormItem label="开启强制更新" prop="remark">
          <RadioGroup v-model="formValidate.refresh">
            <Radio label="开启"></Radio>
            <Radio label="关闭"></Radio>
        </RadioGroup>
        </FormItem>
        <FormItem label="开启更新弹窗" prop="remark">
          <RadioGroup v-model="formValidate.update_popup_switch">
              <Radio :disabled="shouldDisableField" label="开启"></Radio>
              <Radio :disabled="shouldDisableField" label="关闭"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="开启指定版本" v-show="defaultType === '安卓'" prop="remark">
          <RadioGroup v-model="formValidate.multiVerSwitch">
              <Radio  :disabled="shouldDisableField || controlMulti" label="开启"></Radio>
              <Radio  :disabled="shouldDisableField || controlMulti" label="关闭"></Radio>
          </RadioGroup>
          <p class="tip-style">指定版本配置后，版本回退功能将禁用</p>
          <p class="tip-style">指定宿主和筛选条件之间通过“或”逻辑进行组合，即支持配置多个宿主</p>
        </FormItem>
        <FormItem label="指定宿主" prop="remark" v-if="formValidate.multiVerSwitch == '开启'">
          <div v-for="(item, index) in specifyRuntimeList" :key="index">
            <SelectRow
              :packageName="item.packageName"
              :condition="item.condition"
              :version="item.version"
              :index="index"
              :runtimeList="runtimeList"
              :conditionList="conditionList"
              :disabled="shouldDisableField"
              @delete="handleDelete(index, 'specifyRuntimeList')"
              @change="handleRuntimeChange"
            />
          </div>
          <Button :disabled="shouldDisableField" type="primary" icon="md-add" @click="handleAddRuntime">新增</Button>
          <p class="tip-style">指定宿主之间通过“或（OR）”逻辑进行组合，即支持配置多个宿主</p>
          <p class="tip-style">宿主版本号，需三段，中间用小数点分割，例如1.0.0</p>
        </FormItem>
        <FormItem label="筛选条件" prop="remark" v-if="formValidate.multiVerSwitch == '开启'">
          <div v-for="(item, index) in specifyConditionList" :key="index">
          <SelectRowTwo
            :type="item.type"
            :condition="item.condition"
            :version="item.version"
            :channel="item.channel"
            :index="index"
            :conditionTypeList="conditionTypeList"
            :conditionList="conditionList"
            :androidVerList="androidVerList"
            :channelList="channelList"
            :disabled="shouldDisableField"
            @delete="handleDelete(index, 'specifyConditionList')"
            @change="handleConditionChange"
          />
        </div>
        <Button :disabled="shouldDisableField" type="primary" icon="md-add" @click="handleAddCondition">新增</Button>
        <p class="tip-style">当前筛选条件之间通过“且（AND）”逻辑进行组合，即所有条件必须同时满足</p>
        <p class="tip-style">当前筛选条件，如不配置则默认全选</p>
        </FormItem>
        <FormItem :disabled="shouldDisableField" v-if="formValidate.update_popup_switch == '开启'" label="弹窗标题" prop="update_popup_title">
          <Input v-model="formValidate.update_popup_title" maxlength="15" placeholder="请输入弹窗标题，最多15个汉字" />
        </FormItem>
        <FormItem :disabled="shouldDisableField" v-if="formValidate.update_popup_switch == '开启'" label="弹窗更新点" prop="update_popup_message">
          <Input maxlength="100" v-model="formValidate.update_popup_message" type="textarea"  placeholder="展示在电视端，多个更新点可以换行展示，限制100字" :specifyRuntimeList="4" />
        </FormItem>
      </Form>
    </Modal>
    <!-- 小程序二维码弹窗 -->
    <QrCodeModal
      :visible="qrModalVisible"
      :title="qrModalTitle"
      :qr-data="preValidate"
      @update:visible="val => qrModalVisible = val"
      @copy="copyCode"
      @generate="getCode"
    />
    <verify-modal ref="verify"></verify-modal>
    <gray-modal ref="gray" @close="grayModalClose"></gray-modal>
    <gray-table-modal ref="grayTable"></gray-table-modal>
  </div>
</template>

<script>
import grayModal from '@/components/global/grayModal'
import grayTableModal from '@/components/global/grayTableModal'
import breadcrumb from '@/components/global/breadcrumb'
import verifyModal from '@/components/global/verifyModal'
import https from '../../https'
import vueQr from 'vue-qr'
import QrCodeModal from '@/components/global/QrCodeModal'
import SelectRow from './selectRow.vue'
import SelectRowTwo from './selectRowTwo.vue'
import utils from '../../utils'
export default {
  name: 'version',
  /**
   * 版本管理组件数据对象
   * 包含版本管理相关的数据定义和验证规则：
   * 1. 表单验证函数（validateVer/validateMessage/validateFile）
   * 2. 版本相关数据列表（runtimeList/conditionList等）
   * 3. 搜索参数对象（searchParams）
   * 4. 表单验证对象（formValidate）及验证规则（ruleValidate）
   * 5. 表格列定义（columns/columnsGray/columnsOnline）
   * 6. 分页相关数据（dataList/total/pageSize/current）
   * 7. API接口地址配置（urlList）
   */
  data () {
    const validateVer = (rule, value, callback) => {
      callback()
    }
    const validateMessage = (rule, value, callback) => {
      if (this.formValidate.refresh === '开启' && this.formValidate.update_popup_switch === '开启' && !value) {
        callback(new Error('请输入弹窗更新点'))
      } else {
        callback()
      }
      callback()
    }
    const validateFile = (rule, value, callback) => {
      if (this.modalType === 'edit') {
        callback()
      } else if (!value) {
        callback(new Error('请上传代码包'))
      }
      callback()
    }
    return {
      utils,
      specifyRuntimeList: [], // 新增指定版本
      specifyConditionList: [], // 新增筛选条件
      aduit_stats: null,
      onlineVer: {}, // 当前线上版本 记录比较
      editId: '', // 当前编辑id
      uid: '', // 当前用户id
      userId: '', // 登录用户id
      runtimeList: [ // 底座列表
        // { label: '底座', value: '底座' }
      ],
      conditionList: [ // 条件列表
        { label: '>= (大于等于)', value: 'ge', content: '大于等于' },
        { label: '<= (小于等于)', value: 'le', content: '小于等于' },
        { label: '> (大于)', value: 'gt', content: '大于' },
        { label: '< (小于)', value: 'lt', content: '小于' },
        { label: '= (等于)', value: 'eq', content: '等于' },
        { label: '!= (不等于)', value: 'ne', content: '不等于' }
      ],
      conditionTypeList: [ // 渠道｜安卓版本
        { label: '渠道', value: 'channel' },
        { label: '安卓版本', value: 'android' }
      ], // 底座，渠道，安卓版本
      channelList: [], // 渠道列表
      androidVerList: [], // 安卓版本列表
      tvBrandList: [], // 电视品牌列表
      minPluginVerList: [], // 主插件版本列表
      sdkVerList: [], // SDK最小版本列表
      loading: true, // 加载中
      tableLoading: true, // 表格加载中
      showModal: false, // 弹窗是否显示
      package_ver: '', // 小程序分享参数
      controlMulti: false, // 是否控制指定版本
      tvid: '', // 电视id
      appName: '', // 应用名称
      appIcon: '', // 应用图标
      currentAduit: -1, // 当前审核状态
      searchParams: { // 查询参数
        package_ver: '',
        aduit_stats: '',
        package_stats: '',
        sdk_ver_s: '',
        min_plugin_ver_code: '',
        runtime: '',
        runtimeVersion: '',
        channel: '',
        android: '',
        refresh: '',
        updatePopupSwitch: ''
      },
      formValidate: { // 表单验证
        update_popup_title: '新版本',
        package_ver: '',
        min_plugin_ver_code: '',
        remark: '',
        fileName: '',
        files: '',
        sdk_ver_s: '',
        sdk_ver_e: '',
        refresh: '关闭',
        update_popup_switch: '关闭',
        multiVerSwitch: '关闭',
        update_popup_message: ''
      },
      modalType: 'add', // 弹窗类型 add:新增 edit:编辑
      ruleValidate: {
        update_popup_title: [
          { required: true, message: '请输入弹窗标题,最多15个汉字' }
        ],
        package_ver: [
          { required: true, message: '请输入版本号,仅支持输入数字和小数点', trigger: 'blur' },
          { pattern: /^[0-9.]+$/, message: '仅支持输入数字和小数点' }
        ],
        fileName: [
          // { required: false, message: '请上传代码包' }
          { validator: validateFile }
        ],
        sdk_ver_s: [
          { validator: validateVer }
        ],
        sdk_ver_e: [
          { validator: validateVer }
        ],
        update_popup_message: [
          { validator: validateMessage }
        ]
      },
      onlineList: [], // 通用线上版本列表
      grayList: [], // 通用灰度版本列表
      multiOnline: [], // 指定版本线上版本列表
      multiOnlineList: [],
      qrModalVisible: false, // 小程序二维码弹窗是否显示
      qrModalTitle: '', // 小程序二维码弹窗标题
      preValidate: { // 小程序二维码参数
        params: '',
        qrCode: ''
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '版本号',
          key: 'package_ver',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '审核',
          key: 'aduit_stats',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = ''
            switch (params.row.aduit_stats) {
              case 0:
                aduit_stats = '未提审'
                break
              case 1:
                aduit_stats = '待审核'
                break
              case 2:
                aduit_stats = '审核通过'
                break
              case 3:
                aduit_stats = '审核驳回'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.verify.show(params.row, 'app', 'appVer')
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '状态',
          key: 'package_stats',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let package_stats = ''
            if (params.row.multiVerSwitch === 1 || params.row.multiVerSwitch === '开启') {
              switch (params.row.package_stats) {
                case 0:
                  package_stats = '预览版本'
                  break
                case 1:
                  package_stats = '测试版本'
                  break
                case 2:
                  package_stats = '线上版本'
                  break
                case 3:
                  package_stats = '历史版本'
                  break
              }
              let html = [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, '指定'),
                h('span', package_stats)
              ]
              return html
            } else {
              switch (params.row.package_stats) {
                case 0:
                  package_stats = '预览版本'
                  break
                case 1:
                  package_stats = '测试版本'
                  break
                case 2:
                  package_stats = '线上版本'
                  break
                case 3:
                  package_stats = '历史版本'
                  break
              }
              return h('span', package_stats)
            }
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 150
        },
        {
          title: '灰度投放',
          key: 'grayConfStr',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = params.row.grayConfStr
            if (this.defaultType === '鸿蒙') {
              return []
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.grayTable.show(params.row.id)
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '指定版本',
          key: 'multiVerCondition',
          width: 250,
          align: 'left',
          render: (h, params) => {
            if (params.row.multiVerCondition) {
              let html = []
              if (this.defaultType === '鸿蒙') {
                return []
              }
              let arr = JSON.parse(params.row.multiVerCondition)
              arr.map(item => {
                let name = ''
                if (item.type === 'runtime') {
                  name = '宿主'
                  item.list && item.list.map(sItem => {
                    html.push(this.htmlButtonFun(h, `${name}:${this.packageNameFun(sItem.packageName)}-${this.conditionFun(sItem.condition)}-${sItem.version}`))
                  })
                }
                if (item.type === 'android') {
                  name = '安卓版本'
                  html.push(this.htmlButtonFun(h, `${name}:${this.conditionFun(item.condition)}-${this.androidList(item.version)}`))
                }
                if (item.type === 'channel') {
                  name = '渠道'
                  html.push(this.htmlButtonFun(h, `${name}:${this.channelFun(item.channel)}`))
                }
              })
              return html
            }
          }
        },
        {
          title: '驳回原因',
          key: 'aduit_con',
          minWidth: 100
        },
        {
          title: 'SDK版本',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (!params.row.sdk_ver_s && !params.row.sdk_ver_e) {
              name += '不限'
            } else {
              if (params.row.sdk_ver_s) {
                name += params.row.sdk_ver_s
              }
              if (params.row.sdk_ver_e) {
                name += (' - ' + params.row.sdk_ver_e)
              }
            }
            return h('span', name)
          }
        },
        {
          title: '指定主插件版本',
          key: 'minPluginVerCode',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let name = ''
            this.minPluginVerList.map(item => {
              if (item.value === params.row.minPluginVerCode) {
                name = item.text
              }
            })
            return h('span', name)
          }
        },
        {
          title: '强制升级',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.refresh === 1) {
              name = '开启'
            } else {
              name = '关闭'
            }
            return h('span', name)
          }
        },
        {
          title: '更新弹窗',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.updatePopupSwitch === 0) {
              name = '关闭'
            } else {
              name = '开启'
            }
            return h('span', name)
          }
        },
        {
          title: '上传时间',
          key: 'created_at',
          width: 200,
          align: 'center'
        },
        {
          title: '发布时间',
          key: 'pub_at',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.package_stats === 2 || params.row.package_stats === 3 ? params.row.pub_at : '-')
          }
        },
        {
          title: '操作',
          width: 300,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            // 如果当前行数据的审核状态为审核通过（aduit_stats === 2）
            if (params.row.aduit_stats === 2) {
              // 没有通用线上版本或当前为指定预览版本，且包状态不是已发布
              let isMultiPreview = (params.row.multiVerSwitch === 1 || params.row.multiVerSwitch === '开启') && params.row.package_stats === 0
              if ((this.compareVersions(params.row.id) === 0 || isMultiPreview) && params.row.package_stats !== 2) {
                let multiFlag = (params.row.multiVerSwitch === 1 || params.row.multiVerSwitch === '开启') && params.row.package_stats === 3
                btn = [
                  h('Button', {
                    props: {
                      type: 'success',
                      size: 'small',
                      disabled: (this.uid !== this.userId) || multiFlag
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.handlePublish(params.row)
                      }
                    }
                  }, '发布')
                ]
              } else {
                // 如果当前行数据的包状态为已发布（package_stats === 2）且为指定版本（multiVerSwitch === 1）
                if (params.row.package_stats === 2 && params.row.multiVerSwitch === 1) {
                  btn.push(h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small',
                      disabled: (this.uid !== this.userId)
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.stopUseVer(params.row)
                      }
                    }
                  }, '停用'))
                } else {
                  // 如果不是线上版本，且不是指定版本，可以发布或回退
                  // 发布回退按钮禁用逻辑
                  // disabledFlag：当前版本是预览版本且线上版本大于当前版本
                  // isGray: 当前版本灰度停止投放状态
                  let disabledFlag = params.row.package_stats === 0 && this.compareVersions(params.row.id) < 1
                  let isGray = params.row.grayConfStr === '停止投放'
                  let isOnline = params.row.package_stats === 2
                  let multiFlag = (params.row.multiVerSwitch === 1 || params.row.multiVerSwitch === '开启') && params.row.package_stats === 3
                  btn = [
                    h('Button', {
                      props: {
                        type: 'success',
                        size: 'small',
                        disabled: (this.uid !== this.userId) || disabledFlag || isGray || isOnline || multiFlag
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handlePublish(params.row)
                        }
                      }
                    }, this.compareVersions(params.row.id) === 1 ? '发布' : '回退')
                  ]
                }
              }
            } else {
              btn = [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: (params.row.aduit_stats !== 0 || this.uid !== this.userId)
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleAduitVer(params.row)
                    }
                  }
                }, '提审')
              ]
            }
            // 不是测试版本则展示投屏按钮
            if (params.row.package_stats !== 1) {
              btn.push(h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showQrModal(params.row.package_stats === 0 ? 'pre' : 'pro', params.row)
                  }
                }
              }, '投屏'))
            }
            let disabledGrayFlag = params.row.package_stats === 0 && params.row.aduit_stats === 2
            // let verFlag = this.compareVersions(params.row.id) !== 1
            // verFlag
            if (this.defaultType !== '鸿蒙') {
              btn.push(h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (this.uid !== this.userId) || this.dataList.length === 1 || !disabledGrayFlag || params.row.multiVerSwitch === 1
                },
                on: {
                  click: () => {
                    this.$refs.gray.show(params.row.id, 'rpk')
                  }
                }
              }, '灰度'))
            }
            // }
            btn.unshift(h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: (this.uid !== this.userId ? this.uid === 1 : false)
              },
              style: {
                width: '50px',
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.newAlert(params.index, 'edit')
                }
              }
            }, '编辑'))
            // 审核不通过： 在btn的最后添加删除按钮
            if (params.row.aduit_stats !== 2) {
              btn.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: (this.uid !== this.userId ? this.uid === 1 : false)
                  },
                  style: {
                    width: '50px',
                    marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      this.handleDelVer(params.row)
                    }
                  }
                }, '删除'))
            }
            return h('div', btn)
          }
        }
      ],
      columnsGray: [
        {
          title: '版本号',
          key: 'package_ver',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '审核',
          key: 'aduit_stats',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = ''
            switch (params.row.aduit_stats) {
              case 0:
                aduit_stats = '未提审'
                break
              case 1:
                aduit_stats = '待审核'
                break
              case 2:
                aduit_stats = '审核通过'
                break
              case 3:
                aduit_stats = '审核驳回'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.verify.show(params.row, 'app', 'appVer')
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '状态',
          key: 'package_stats',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let package_stats = ''
            switch (params.row.package_stats) {
              case 0:
                package_stats = '预览版本'
                break
              case 1:
                package_stats = '测试版本'
                break
              case 2:
                package_stats = '线上版本'
                break
              case 3:
                package_stats = '历史版本'
                break
            }
            return h('span', package_stats)
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 150
        },
        {
          title: '灰度投放',
          key: 'grayConfStr',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = params.row.grayConfStr
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.grayTable.show(params.row.id)
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '指定版本',
          key: 'multiVerCondition',
          width: 250,
          align: 'left',
          render: (h, params) => {
            if (params.row.multiVerCondition) {
              let html = []
              let arr = JSON.parse(params.row.multiVerCondition)
              arr.map(item => {
                let name = ''
                if (item.type === 'runtime') {
                  name = '宿主'
                  item.list && item.list.map(sItem => {
                    html.push(this.htmlButtonFun(h, `${name}:${this.packageNameFun(sItem.packageName)}-${this.conditionFun(sItem.condition)}-${sItem.version}`))
                  })
                }
                if (item.type === 'android') {
                  name = '安卓版本'
                  html.push(this.htmlButtonFun(h, `${name}:${this.conditionFun(item.condition)}-${this.androidList(item.version)}`))
                }
                if (item.type === 'channel') {
                  name = '渠道'
                  html.push(this.htmlButtonFun(h, `${name}:${this.channelFun(item.channel)}`))
                }
              })
              return html
            }
          }
        },
        {
          title: '驳回原因',
          key: 'aduit_con',
          minWidth: 100
        },
        {
          title: 'SDK版本',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (!params.row.sdk_ver_s && !params.row.sdk_ver_e) {
              name += '不限'
            } else {
              if (params.row.sdk_ver_s) {
                name += params.row.sdk_ver_s
              }
              if (params.row.sdk_ver_e) {
                name += (' - ' + params.row.sdk_ver_e)
              }
            }
            return h('span', name)
          }
        },
        {
          title: '指定主插件版本',
          key: 'minPluginVerCode',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let name = ''
            this.minPluginVerList.map(item => {
              if (item.value === params.row.minPluginVerCode) {
                name = item.text
              }
            })
            return h('span', name)
          }
        },
        {
          title: '强制升级',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.refresh === 1) {
              name = '开启'
            } else {
              name = '关闭'
            }
            return h('span', name)
          }
        },
        {
          title: '更新弹窗',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.updatePopupSwitch === 0) {
              name = '关闭'
            } else {
              name = '开启'
            }
            return h('span', name)
          }
        },
        {
          title: '上传时间',
          key: 'created_at',
          width: 200,
          align: 'center'
        },
        {
          title: '发布时间',
          key: 'pub_at',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.package_stats === 2 || params.row.package_stats === 3 ? params.row.pub_at : '-')
          }
        }
      ],
      columnsOnline: [
        {
          title: '版本号',
          key: 'package_ver',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '审核',
          key: 'aduit_stats',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let aduit_stats = ''
            switch (params.row.aduit_stats) {
              case 0:
                aduit_stats = '未提审'
                break
              case 1:
                aduit_stats = '待审核'
                break
              case 2:
                aduit_stats = '审核通过'
                break
              case 3:
                aduit_stats = '审核驳回'
                break
            }
            let html = [
              h('span', {
                style: {
                  cursor: 'pointer',
                  color: params.row.aduit_stats === 0 ? 'black' : 'blue'
                },
                on: {
                  click: () => {
                    if (params.row.aduit_stats !== 0) {
                      this.$refs.verify.show(params.row, 'app', 'appVer')
                    }
                  }
                }
              }, aduit_stats)
            ]
            return html
          }
        },
        {
          title: '状态',
          key: 'package_stats',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let package_stats = ''
            switch (params.row.package_stats) {
              case 0:
                package_stats = '预览版本'
                break
              case 1:
                package_stats = '测试版本'
                break
              case 2:
                package_stats = '线上版本'
                break
              case 3:
                package_stats = '历史版本'
                break
            }
            return h('span', package_stats)
          }
        },
        {
          title: '驳回原因',
          key: 'aduit_con',
          minWidth: 100
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 300
        },
        {
          title: 'SDK版本',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (!params.row.sdk_ver_s && !params.row.sdk_ver_e) {
              name += '不限'
            } else {
              if (params.row.sdk_ver_s) {
                name += params.row.sdk_ver_s
              }
              if (params.row.sdk_ver_e) {
                name += (' - ' + params.row.sdk_ver_e)
              }
            }
            return h('span', name)
          }
        },
        {
          title: '指定主插件版本',
          key: 'minPluginVerCode',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let name = ''
            this.minPluginVerList.map(item => {
              if (item.value === params.row.minPluginVerCode) {
                name = item.text
              }
            })
            return h('span', name)
          }
        },
        {
          title: '强制升级',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.refresh === 1) {
              name = '开启'
            } else {
              name = '关闭'
            }
            return h('span', name)
          }
        },
        {
          title: '更新弹窗',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (params.row.updatePopupSwitch === 0) {
              name = '关闭'
            } else {
              name = '开启'
            }
            return h('span', name)
          }
        },
        {
          title: '上传时间',
          key: 'created_at',
          width: 200,
          align: 'center'
        },
        {
          title: '发布时间',
          key: 'pub_at',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.package_stats === 2 || params.row.package_stats === 3 ? params.row.pub_at : '-')
          }
        }
      ],
      urlList: {
        offlineMulti: 'extscreenapi/plugin/hili/v2/es/ver/offlineMulti',
        runtimePluginVersion: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_plugin_version',
        specifiedBase: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=specified_base',
        androidVersion: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=android_version',
        channelList: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=app_channel_code',
        tvBrand: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=tv_brand'
      },
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      defaultType: '安卓'
    }
  },
  components: {
    grayTableModal,
    grayModal,
    breadcrumb,
    verifyModal,
    vueQr,
    SelectRow,
    SelectRowTwo,
    QrCodeModal
  },
  watch: {
  },
  /**
   * 组件创建生命周期钩子
   * 1. 检查token是否存在，不存在则跳转首页
   * 2. 从路由query中获取并初始化以下数据：
   *    - tvid: 电视ID
   *    - name: 应用名称
   *    - icon: 应用图标
   *    - aduit_stats: 审核状态(转换为数字)
   *    - uid: 用户ID
   * 3. 从localStorage获取userId
   * 4. 调用多个方法获取相关数据：
   *    - 获取指定基础信息
   *    - 获取Android版本
   *    - 获取渠道信息
   *    - 获取电视品牌列表
   *    - 获取最小插件版本
   *    - 获取版本列表
   *    - 加载其他数据
   */
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.tvid = this.$route.query.tvid
    this.appName = this.$route.query.name
    this.appIcon = this.$route.query.icon
    this.aduit_stats = Number(this.$route.query.aduit_stats)
    this.uid = this.$route.query.uid
    this.userId = localStorage.getItem('userId')
    this.getSpecifiedBase()
    this.getAndroidVersion()
    this.getChannel()
    this.getTvBrandList()
    this.getMinPluginVer()
    this.getVerList()
    this.loadData()
  },
  computed: {
    shouldDisableField () {
      return this.modalType === 'edit' && this.currentAduit === -1
    }
  },
  methods: {
    /**
     * 关闭灰度弹窗后重新加载数据
     */
    grayModalClose () {
      this.loadData()
    },
    /**
     * 获取线上版本信息
     * @description 通过API请求获取当前设备的线上版本信息，并处理返回结果
     * @returns {void}
     */
    getOnlineVer () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/ver/getOnlineVer',
        params: {
          tvId: this.tvid,
          os: this.defaultType === '安卓' ? 0 : 1,
          ...this.searchParams
        }
      }).then(res => {
        console.log('线上版本列表', res)
        if (res.code === 200) {
          this.getGrayStatusFun([res.result], 'online')
          return
        }
        if (res.result === null) {
          this.onlineList = []
          this.getGrayStatusFun([], 'online')
          // return
        }
      })
    },
    /**
     * 获取在线版本信息并控制多选编辑状态
     * 通过请求接口获取当前设备的在线版本信息，根据返回结果设置controlMulti状态
     * 如果请求失败或返回结果为空，则允许多选编辑(controlMulti=true)
     * 否则禁止多选编辑(controlMulti=false)
     */
    controlMultiEdit () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/ver/getOnlineVer',
        params: {
          tvId: this.tvid,
          os: this.defaultType === '安卓' ? 0 : 1
        }
      }).then(res => {
        if (res.code !== 200 || res.result === null) {
          this.onlineVer = {}
          this.controlMulti = true
        } else {
          this.onlineVer = res.result
          this.controlMulti = false
        }
      })
    },
    /**
     * 获取灰度版本信息
     * 通过API请求获取当前设备的灰度版本列表
     * @returns {Promise} 返回包含灰度版本信息的Promise对象
     */
    getGrayVer () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/getGrayListAfterOnline?tvId=' + this.tvid,
        params: {
          tvId: this.tvid,
          ...this.searchParams
        }
      }).then(res => {
        console.log('灰度版本列表', res)
        this.getGrayStatusFun(res.result, 'gray')
      })
    },
    /**
     * 比较两个版本号
     * @param {string} version1 - 本地版本号
     * @returns {number} 比较结果：1(version1较大), -1(version1较小), 0(版本相同或onlineVer不存在)
     */
    compareVersions (version1) {
      if (this.onlineVer) {
        let version2 = this.onlineVer.id
        if (version1 > version2) {
          return 1
        } else if (version1 < version2) {
          return -1
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    /**
     * 获取SDK版本列表
     * 通过API请求获取字典项为runtime_sdk_version的数据
     * 成功后将结果赋值给sdkVerList
     */
    getVerList () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_sdk_version'
      }).then(res => {
        console.log(res)
        this.sdkVerList = res.result
      })
    },
    /**
     * 获取运行时插件的最低版本号
     * @description 通过API请求获取运行时插件的最低版本列表，成功时将结果存入minPluginVerList，失败时显示错误信息
     */
    getMinPluginVer () {
      https.request({
        method: 'get',
        url: this.urlList.runtimePluginVersion
      }).then(res => {
        this.minPluginVerList = res.result
      }).catch(error => {
        this.$Message.error(error)
      })
      /**
       * 清空搜索参数并重新加载数据
       */
    },
    handleSearch () {
      if (this.searchParams.runtime && this.searchParams.runtimeVersion === '') {
        this.$Message.error('请输入宿主版本')
        return
      } else if (this.searchParams.runtimeVersion && !this.searchParams.runtime) {
        this.$Message.error('请输入宿主名称')
        return
      }
      this.loadData()
    },
    /**
     * 清空搜索参数并重新加载数据
     */
    handleClear () {
      this.searchParams = {}
      this.loadData()
    },
    /**
     * 清除审核状态并重新加载数据
     */
    clearAuditState () {
      this.loadData()
    },
    /**
     * 处理版本发布
     * 弹出确认框，确认后发送PUT请求发布指定版本
     * 成功后显示成功消息并重新加载数据
     * 失败时显示错误消息
     * @param {Object} row - 要发布的版本信息
     * */
    handlePublish (row) {
      // 如果当前版本是线上版本，且线上版本大于当前版本，提示回退
      let content = ''
      if (this.compareVersions(row.id) === -1) {
        content = '默认全量并强制更新该版本。'
      } else {
        content = row.grayConfStr ? '当前版本配置了灰度投放，发布后灰度投放策略不生效，默认全量发布。' : ''
      }
      this.$Modal.confirm({
        title: `确定发布【${row.package_ver}】为线上版本吗？`,
        content: content,
        onOk: () => {
          https.request({
            method: 'put',
            url: 'extscreenapi/plugin/hili/v2/es/setOnlineVer',
            params: {
              id: row.id
            }
          }).then(res => {
            console.log('版本发布-----:', res)
            if (res.code === 400) {
              this.$Message.error(res.message)
              return
            }
            this.$Message.success('成功')
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    /**
     * 停用指定版本
     * @param {Object} row - 版本行数据
     * @description 弹出确认框询问用户是否停用版本，确认后发送停用请求
     * 停用成功后刷新数据，失败则显示错误信息
     */
    stopUseVer (row) {
      this.$Modal.confirm({
        title: `确认停用`,
        content: '确认要停用该版本的指定投放吗？停止后，已筛选指定版本并打开当前版本的用户，下次再打开应用将自动回退到上一个版本。',
        okText: '确认停用',
        onOk: () => {
          https.request({
            method: 'put',
            url: this.urlList.offlineMulti,
            params: {
              verId: row.id
            }
          }).then(res => {
            this.$Message.success('停用成功')
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    /**
     * 提交版本审核
     * @param {Object} row - 版本行数据对象
     * @param {string} row.id - 版本ID
     * @description 调用审核接口提交版本审核，成功后会刷新数据并提示成功信息
     */
    handleAduitVer (row) {
      https.request({
        method: 'get',
        url: '/v1/tvpver/aduit',
        params: {
          id: row.id,
          sta: 1
        }
      }).then(res => {
        this.$Message.success('提交审核成功')
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    handleDelVer (row) {
      if (row.aduit_stats === 2) {
        this.$Message.error('版本审核已通，不能删除')
        return
      }
      this.$Modal.confirm({
        title: `删除提示`,
        content: `确定删除【${row.package_ver}】吗？`,
        onOk: () => {
          https.request({
            method: 'put',
            url: 'extscreenapi/plugin/hili/v2/es/delVersion?id=' + row.id
          }).then(res => {
            if (res.code === 400) {
              this.$Message.error(res.message)
              return
            }
            this.$Message.success('删除成功')
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    /**
     * 加载版本数据
     * 发送GET请求获取版本列表数据，处理分页和搜索参数
     * 请求成功后更新在线版本、灰度版本、多版本在线状态等数据
     * 失败时显示错误信息
     * @returns {Promise} 返回请求的Promise对象
     */
    loadData () {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        tvId: this.tvid,
        os: this.defaultType === '安卓' ? 0 : 1,
        ...this.searchParams
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/ver/app/vers',
        params: params
      }).then(res => {
        this.getOnlineVer()
        this.controlMultiEdit()
        this.getGrayVer()
        this.tableLoading = false
        this.getGrayStatusFun(res.data.items)
        this.getMultiOnline()
        this.total = res.data.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 获取多版本线上之后的灰度版本列表
     * @returns {Promise} 返回包含灰度版本列表的Promise
     */
    getGrayOnline () {
      let onlineId = ''
      if (this.multiOnline.length > 0) {
        onlineId = this.multiOnline[0].id
      }
      let params = {
        tvId: this.tvid,
        ...this.searchParams,
        onlineId
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/ver/getMultiGrayListAfterOnline',
        params: params
      }).then(res => {
        console.log('获取多版本线上版本之后的灰度版本', res)
        this.getGrayStatusFun(res.result, 'multiGray')
      })
    },
    /**
     * 获取多版本线上版本列表
     * @returns {Promise} 返回包含多版本线上版本列表的Promise
     */
    getMultiOnline () {
      let params = {
        tvId: this.tvid,
        ...this.searchParams
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/v2/es/ver/getMultiOnlineVer',
        params: params
      }).then(res => {
        // this.multiOnline = res.result
        this.getGrayStatusFun(res.result, 'multiOnline')
        this.getGrayOnline()
      })
    },
    /**
     * 获取灰度配置状态
     * @param {Array} list - 需要查询的列表数据
     * @param {string} [type='list'] - 返回数据存储的目标列表类型
     * @description 通过id列表查询灰度配置，并将结果更新到对应列表中
     */
    getGrayStatusFun (list, type = 'list') {
      let arr = []
      list.map(item => {
        arr.push(item.id)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `extscreenapi/plugin/hili/v2/es/getGrayConfig?idList=${str}`,
        params: {}
      }).then(res => {
        res.result.map(item => {
          list.map(sItem => {
            if (Number(item.dataId) === sItem.id) {
              sItem['grayConfStr'] = item.grayConfStr
            }
          })
        })
        if (type === 'list') {
          this.dataList = list
        } else if (type === 'gray') {
          this.grayList = list
        } else if (type === 'multiGray') {
          this.multiOnlineList = list
        } else if (type === 'multiOnline') {
          this.multiOnline = list
        } else {
          this.onlineList = list
        }
      })
    },
    /**
     * 获取指定基础数据
     * 通过API请求获取指定基础数据列表，并将结果映射到runtimeList中
     * @returns {void}
     */
    getSpecifiedBase () {
      https.request({
        method: 'get',
        url: this.urlList.specifiedBase
      }).then(res => {
        res.result.map(item => {
          this.runtimeList.push({
            label: item.text,
            value: item.value
          })
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 获取安卓版本列表
     * 通过API请求获取安卓版本数据，并将结果格式化为{label,value}格式存入androidVerList
     * 请求失败时显示错误信息
     */
    getAndroidVersion () {
      https.request({
        method: 'get',
        url: this.urlList.androidVersion
      }).then(res => {
        res.result.map(item => {
          this.androidVerList.push({
            label: item.text,
            value: item.value
          })
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 获取渠道列表
     */
    getChannel () {
      https.request({
        method: 'get',
        url: this.urlList.channelList
      }).then(res => {
        res.result.map((item, index) => {
          if (item.value === 'ALLCHANNEL') {
            res.result.splice(index, 1)
          }
          if (item.value === 'CESHI') {
            res.result.splice(index, 1)
          }
          if (item.value === 'GENERAL') {
            res.result.splice(index, 1)
          }
        })
        res.result.map(item => {
          this.channelList.push({
            label: item.text,
            value: item.value
          })
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    uploadFile (name) {
      let file = this.$refs[name].files[0]
      this.formValidate.files = file
      this.formValidate.fileName = file.name
    },
    /**
     * 投屏
     * @param {*} type pre 生成线上版本二维码/ pro 生成预览版本二维码
     * @param {*} row 数据
     */
    showQrModal (env, row) {
      this.qrModalTitle = env === 'pro' ? '生成线上版本二维码' : '生成预览版本二维码'
      this.package_ver = row.package_ver
      this.qrModalVisible = true
    },
    /**
     * 复制小程序分享码
     */
    copyCode () {
      const params = {
        query: `tvid_ver=${this.tvid}_${this.package_ver}`
      }
      https.request({
        method: 'get',
        url: '/v1/miniprogram/app/share',
        params: params
      }).then(res => {
        this.copyToClip(res.data)
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 获取小程序分享码
     */
    getCode () {
      const params = {
        query: `tvid_ver=${this.tvid}_${this.package_ver}`
      }
      https.request({
        method: 'get',
        url: '/v1/miniprogram/qrcode',
        params: params
      }).then(res => {
        this.preValidate.qrCode = `data:image/png;base64,${res.data}`
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 取消弹窗
     */
    cancelModal () {
      this.$refs['formValidate'].resetFields()
      this.formValidate.update_popup_switch = '关闭'
      this.formValidate.refresh = '关闭'
      this.formValidate.update_popup_title = '新版本'
      this.formValidate.update_popup_message = ''
      this.specifyRuntimeList = []
      this.specifyConditionList = []
    },
    /**
     * 新建或编辑版本弹窗
     * @param {number} index - 数据索引，非数字时为新建
     * @param {string} [type='add'] - 操作类型：'add' 新建，'edit' 编辑
     * @description
     * 1. 处理数据列表指定索引项的显示状态转换
     * 2. 解析多版本条件数据(runtime/channel/android)
     * 3. 重置表单字段（新建时）
     * 4. 设置审核状态（编辑时）
     */
    newAlert (index, type = 'add') {
      this.modalType = type
      if (!isNaN(index)) {
        this.specifyRuntimeList = []
        this.specifyConditionList = []
        this.dataList[index].update_popup_switch = this.dataList[index].updatePopupSwitch === 0 ? '关闭' : '开启'
        this.dataList[index].multiVerSwitch = this.dataList[index].multiVerSwitch === 0 || this.dataList[index].multiVerSwitch === '关闭' ? '关闭' : '开启'
        this.dataList[index].update_popup_title = this.dataList[index].updatePopupTitle
        this.dataList[index].update_popup_message = this.dataList[index].updatePopupMessage
        this.dataList[index].min_plugin_ver_code = this.dataList[index].minPluginVerCode
        this.formValidate = {...this.dataList[index], refresh: this.dataList[index].refresh === 1 ? '开启' : '关闭'}
        let multiVerCondition = JSON.parse(this.dataList[index].multiVerCondition) || []
        multiVerCondition.map(item => {
          if (item.type === 'runtime') {
            item.list.map(sItem => {
              this.specifyRuntimeList.push({
                type: 'runtime',
                packageName: sItem.packageName,
                condition: sItem.condition,
                version: sItem.version
              })
            })
          } else if (item.type === 'channel') {
            this.specifyConditionList.push({
              type: 'channel',
              channel: item.channel.split(',')
            })
          } else if (item.type === 'android') {
            this.specifyConditionList.push({
              type: 'android',
              condition: item.condition,
              version: item.version
            })
          }
        })
      } else {
        this.$refs['formValidate'].resetFields()
        this.formValidate.min_plugin_ver_code = ''
        this.formValidate.files = ''
      }
      if (type === 'edit') {
        this.editId = this.dataList[index].id
        if (this.dataList[index].aduit_stats === 0 || this.dataList[index].aduit_stats === 3) {
          this.currentAduit = this.dataList[index].aduit_stats
        } else {
          this.currentAduit = -1
        }
      }
      this.showModal = true
    },
    /**
     * 编辑数据并提交表单
     * @param {string} form - 表单ref名称
     * @description
     * 1. 验证表单有效性
     * 2. 当开启多版本校验时，检查指定宿主和筛选条件是否填写完整
     * 3. 根据modalType区分新增/编辑操作
     * 4. 构造FormData参数并发送请求
     * 5. 处理请求结果，包括成功/失败提示和状态重置
     */
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 开启指定版本校验
          if (this.formValidate.multiVerSwitch === '开启') {
            // 指定宿主和筛选条件，必须有一个填写才能保存成功
            if (this.specifyRuntimeList.length === 0 && this.specifyConditionList.length === 0) {
              this.$Message.error('请填写指定宿主或筛选条件')
              this.changeLoading()
              return
            }
            const hasEmptyRuntime = this.specifyRuntimeList.some(item =>
              !item.packageName || !item.condition || !item.version
            )
            const hasEmptyCondition = this.specifyConditionList.some(item => {
              if (item.type === 'android') {
                return !item.condition || !item.version
              }
              if (item.type === 'channel') {
                return !item.channel || item.channel.length === 0
              }
              return false
            })
            // 请完善所有配置项内容
            if (hasEmptyRuntime || hasEmptyCondition) {
              this.$Message.error('请完善所有配置项内容')
              this.changeLoading()
              return
            }
          }
          setTimeout(() => {
            let params = new FormData()
            if (this.modalType === 'add') {
              params.append('tvid', this.tvid)
              params.append('files', this.formValidate.files)
              params.append('package_ver', this.formValidate.package_ver)
              params.append('remark', this.formValidate.remark)
              params.append('min_plugin_ver_code', this.formValidate.min_plugin_ver_code || '')
              params.append('refresh', this.formValidate.refresh === '关闭' ? 2 : 1)
              params.append('update_popup_switch', this.formValidate.update_popup_switch === '关闭' ? 0 : 1)
              params.append('multiVerSwitch', this.formValidate.multiVerSwitch === '关闭' ? 0 : 1)
              params.append('update_popup_title', this.formValidate.update_popup_title || '')
              params.append('update_popup_message', this.formValidate.update_popup_message || '')
              params.append('sdk_ver_s', this.formValidate.sdk_ver_s === 'all' ? '' : this.formValidate.sdk_ver_s)
              params.append('sdk_ver_e', this.formValidate.sdk_ver_e === 'all' ? '' : this.formValidate.sdk_ver_e)
              params.append('os', this.defaultType === '安卓' ? 0 : 1)
              // 开启指定版本需要清洗数据
              if (this.formValidate.multiVerSwitch === '开启') {
                let obj = {
                  type: 'runtime',
                  list: []
                }
                this.specifyRuntimeList.map(item => {
                  obj.list.push({
                    packageName: item.packageName,
                    condition: item.condition,
                    version: item.version
                  })
                })
                this.specifyConditionList.map(item => {
                  if (item.type === 'channel') {
                    item.channel = item.channel.toString()
                  }
                })
                let multiVerCondition = [obj, ...this.specifyConditionList]
                params.append('multiVerCondition', JSON.stringify(multiVerCondition) || '')
              }
              https.request({
                method: 'post',
                url: 'extscreenapi/plugin/hili/v2/es/add',
                data: params,
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(res => {
                this.changeLoading()
                if (res.code === 400 || res.code === 500) {
                  this.$Message.error(res.message)
                  return
                }
                this.formValidate.multiVerSwitch = '关闭'
                this.specifyRuntimeList = []
                this.specifyConditionList = []
                this.$Message.success('上传成功')
                this.showModal = false
                this.loadData()
                this.cancelModal()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              params.append('tvid', this.tvid)
              if (this.formValidate.files) {
                params.append('files', this.formValidate.files)
              }
              console.log('保存获取状态', this.formValidate.update_popup_switch)
              params.append('id', this.editId)
              params.append('package_ver', this.formValidate.package_ver)
              params.append('remark', this.formValidate.remark)
              params.append('min_plugin_ver_code', this.formValidate.min_plugin_ver_code || '')
              params.append('refresh', this.formValidate.refresh === '关闭' ? 2 : 1)
              params.append('update_popup_switch', this.formValidate.update_popup_switch === '关闭' ? 0 : '1')
              params.append('multiVerSwitch', this.formValidate.multiVerSwitch === '关闭' ? 0 : '1')
              params.append('update_popup_title', this.formValidate.update_popup_title || '')
              params.append('update_popup_message', this.formValidate.update_popup_message || '')
              params.append('sdk_ver_s', this.formValidate.sdk_ver_s === 'all' ? '' : this.formValidate.sdk_ver_s)
              params.append('sdk_ver_e', this.formValidate.sdk_ver_e === 'all' ? '' : this.formValidate.sdk_ver_e)
              params.append('os', this.defaultType === '安卓' ? 0 : 1)
              if (this.formValidate.multiVerSwitch === '开启') {
                let obj = {
                  type: 'runtime',
                  list: []
                }
                this.specifyRuntimeList.map(item => {
                  obj.list.push({
                    packageName: item.packageName,
                    condition: item.condition,
                    version: item.version
                  })
                })
                this.specifyConditionList.map(item => {
                  if (item.type === 'channel') {
                    item.channel = item.channel.toString()
                  }
                })
                let multiVerCondition = [obj, ...this.specifyConditionList]
                console.log('multiVerCondition', multiVerCondition)
                params.append('multiVerCondition', JSON.stringify(multiVerCondition) || '')
              }
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/v2/es/updatePackageVer',
                data: params,
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(res => {
                console.log(res)
                this.changeLoading()
                if (res.code === 500) {
                  this.$Message.error(res.message)
                  return
                }
                if (res.data && res.code === 400) {
                  this.$Message.error(res.data.msg)
                  return
                }
                this.$Message.success('成功')
                this.showModal = false
                this.formValidate.multiVerSwitch = '关闭'
                this.specifyRuntimeList = []
                this.specifyConditionList = []
                this.formValidate.files = ''
                this.formValidate.fileName = ''
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    /**
     * 删除应用
     * @param index 应用索引
     */
    delItem (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].name + '</span> 吗？</p>',
        onOk: () => {
          https.request({
            method: 'delete',
            url: '/v1/application/' + this.dataList[index].id
          }).then(res => {
            this.$Message.success('删除成功')
            if (this.dataList.length === 1 && this.current > 1) this.current -= 1
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    /**
     * 添加指定宿主
     */
    handleAddRuntime () {
      this.specifyRuntimeList.push({
        type: 'runtime',
        packageName: '',
        condition: '',
        version: ''
      })
    },
    /**
     * 添加指定条件
     */
    handleAddCondition () {
      this.specifyConditionList.push({
        type: 'android',
        condition: '',
        version: ''
      })
    },
    /**
     * 删除指定宿主或条件
     * @param index 索引
     * @param type 类型
     */
    handleDelete (index, type) {
      if (type === 'specifyRuntimeList') {
        this.specifyRuntimeList.splice(index, 1)
      } else if (type === 'specifyConditionList') {
        this.specifyConditionList.splice(index, 1)
      }
    },
    /**
     * 指定宿主修改 回调
     * @param Object val 底座对象
     * @param Number index 索引
     * @param String packageName 包名
     * @param String condition 条件
     * @param String version 版本号
     */
    handleRuntimeChange ({ index, packageName, condition, version }) {
      this.$set(this.specifyRuntimeList, index, { type: 'runtime', packageName, condition, version })
    },
    /**
     * 指定条件修改 回调
     * @param Object val 条件对象
     * @param Number index 索引
     * @param String type 类型
     * @param String condition 条件
     * @param String version 版本号
     * @param Array channel 渠道数组
     */
    handleConditionChange ({ index, type, condition, version, channel }) {
      if (type === 'channel') {
        this.$set(this.specifyConditionList, index, { type, channel })
        return
      }
      this.$set(this.specifyConditionList, index, { type, condition, version })
    },
    /**
     * 获取电视品牌列表
     */
    getTvBrandList () {
      https.request({
        method: 'get',
        url: this.urlList.tvBrand
      }).then(res => {
        this.tvBrandList = res.result
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    /**
     * 复制内容
     * @param content 复制的内容
     */
    copyToClip (content) {
      var aux = document.createElement('input')
      aux.setAttribute('value', content)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$Message.success('复制成功')
    },
    /**
     * 条件过滤
     * @param val 条件
     */
    conditionFun (val) {
      let value = ''
      this.conditionList.map(item => {
        if (item.value === val) {
          value = item.content
        }
      })
      return value
    },
    /**
     * 安卓版本过滤
     * @param val 安卓版本号
     */
    androidList (val) {
      let value = ''
      utils.androidVersions.map(item => {
        if (item.value === Number(val)) {
          value = item.label
        }
      })
      return `Android ${value}`
    },
    /**
     * 包名过滤
     * @param val 包名
     */
    packageNameFun (val) {
      let value = ''
      this.runtimeList.map(item => {
        if (item.value === val) {
          value = item.label
        }
      })
      return value
    },
    /**
     * 渠道过滤
     * @param val 渠道数组
     */
    channelFun (val) {
      let value = ''
      let channelArr = []
      if (val.length > 0) {
        channelArr = val && val.split(',')
      }
      this.channelList.map(item => {
        channelArr.map(sItem => {
          if (item.value === sItem) {
            value += item.label + ','
          }
        })
      })
      return value
    },
    /**
     * 表格-指定版本-Tag渲染
     * @param h vue的h函数
     * @param val 按钮的文字
     */
    htmlButtonFun (h, val) {
      return h('Button', {
        props: {
          size: 'small'
        },
        style: {
          marginBottom: '5px',
          marginTop: '5px'
        }
      }, val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  /* 二维码 */
  .code-box {
    display: inline-block;
    border: 1px solid #dcdee2;
    padding: 15px;
    text-align: center;
    line-height: 1;
  }
  .code-box p {
    margin-top: 15px;
  }
  .code-box img {
    width:200px;
    height:200px;
  }
  .select-box-name{
    display: flex;
    position: absolute;
    top: 20px;
    right:28px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select_icon_url{
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
  .version-col{
    margin-top:10px;
  }
  .tip-style{
    font-size:12px;
    color:#c00;
  }
  .file_must_ic{
    position: absolute;
    top: 12px;
    left: -96px;
    width:15px;
    height:10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/esApp/version.vue